import useEnumValues from 'app/hooks/useEnumValues'
import FormWithControls from 'app/shared-components/FormWithControls'
import {
    ActionComponentCreateProps,
} from 'app/shared-components/SkyNetDomain/SkyNetDomain.types'
import requests from 'app/requests/Container/Damage.requests'
import WarningCard from 'app/shared-components/WarningCard'

import getDamageCreateFields from './DamageCreate.fields'
import useStyles from './DamageCreate.styles'

const DamageCreate = ({
    onSuccess,
}: ActionComponentCreateProps) => {
    const {
        classes,
    } = useStyles()
    const getAllowedValue = useEnumValues()

    return (
        <>
            <WarningCard>
                <div>
                    <span className={classes.bold}>IMPORTANT</span>
                    : Creating or fixing damages can result in automatic container status changes.
                </div>
            </WarningCard>
            <FormWithControls
                onSuccess={onSuccess}
                name="Damage"
                fields={getDamageCreateFields(getAllowedValue)}
                requestParams={requests.create()}
            />
        </>
    )
}

export default DamageCreate
